import { Component } from '@angular/core';

@Component({
  selector: 'app-pricing',
  standalone: false,
  templateUrl: './pricing.html',
  styleUrl: './pricing.css'
})
export class Pricing {
  isAnnual = true;

  toggleBilling() {
    this.isAnnual = !this.isAnnual;
  }
}
